import { Theme } from '@truepill/react-capsule'
import { FC } from 'react'

import { GlobalStyle } from './components'
import { ToastProvider } from './libs/toast'
import { ModalProvider } from './providers/ModalProvider'
import PaneProvider from './providers/PaneProvider'
import { Router } from './routes'
import { capsuleOverrides } from './styles'

export const App: FC = () => {
  return (
    <Theme overrides={capsuleOverrides}>
      <GlobalStyle />
      <ModalProvider>
        <ToastProvider>
          <PaneProvider>
            <Router />
          </PaneProvider>
        </ToastProvider>
      </ModalProvider>
    </Theme>
  )
}
